import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <img src="/Progility.png" alt="Progility Logo" className="footer-logo" />
        <p className="footer-text">
          Discover a premier digital consumer brand offering comprehensive travel information and inspiration. With a rich heritage of over 30 years in print and two decades online, this platform provides accurate content on top global destinations. From cities and airports to resorts and attractions, our dedicated editorial team updates the portal daily, attracting millions of unique users monthly.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
